import { AxiosResponse } from 'axios';
import { api } from '../providers/base-api';

export interface SectorDailyLogDto {
  id: number;
  date: string;
  sector: string;
  employeeCodes: string[];
  createdAt: string;
  registeredBy: { id: number; username: string };
}

export interface UpsertSectorDailyLogData {
  date: string;
  sector: string;
  employeeCodes: string[];
}

export const upsertSectorDailyLogRequest = (
  data: UpsertSectorDailyLogData,
): Promise<AxiosResponse<SectorDailyLogDto>> =>
  api.post('/sector-daily-logs', data);

export const listSectorDailyLogsByDateRequest = (
  date: string,
): Promise<AxiosResponse<SectorDailyLogDto[]>> =>
  api.get('/sector-daily-logs', { params: { date } });

export const getSectorDailyLogRequest = (
  date: string,
  sector: string,
): Promise<AxiosResponse<SectorDailyLogDto | null>> =>
  api.get('/sector-daily-logs/sector', { params: { date, sector } });

export const findEmployeeSectorRequest = (
  code: string,
  date: string,
): Promise<AxiosResponse<SectorDailyLogDto[]>> =>
  api.get('/sector-daily-logs/employee', { params: { code, date } });

export interface EnrichedEmployee {
  accessCode: string;
  username: string;
  role: string;
  workScaleName: string | null;
}

export interface EnrichedSectorLog {
  id: number;
  date: string;
  sector: string;
  registeredBy: { id: number; username: string };
  employees: EnrichedEmployee[];
}

export const getEnrichedSectorLogsRequest = (
  date: string,
  sector?: string,
): Promise<AxiosResponse<EnrichedSectorLog[]>> =>
  api.get('/sector-daily-logs/enriched', { params: { date, sector } });
